import styled, { css } from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex: 1;
`;

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    display: flex;
    justify-content: center;
    max-width: 100%;
    width: 100%;
  `}
`;

export const ImageWrapper = styled.div`
  ${({ theme }) => css`
    background-color: #F9F9F9;
    display: flex;
    justify-content: center;
    max-width: 800px;
    padding-left: 30px;
    width: 100%;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const SuccessImage = styled.img`
  height: fit-content;
  max-width: 706px;
  margin: 8% 0px 0px 0;
  width: 100%;
`;

export const InfoContentWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    display: flex;
    flex-direction: column;
    padding: 20% 76px 0px 76px;
    width: 100%;
    @media (max-width: ${theme.v2.breakpoints.lg}) {
      padding: 20% 40px 0px 40px;
    }
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 20% 20px 0px 20px;
    }
  `}
`;

export const SuccessTitle = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    text-align: center;
    margin: 16px 0;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.sm};
    }
  `}
`;

export const SuccessDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.regular};
    text-align: center;
    margin-bottom: 40px;
    margin-top: 0px;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
      margin-bottom: 32px;
    }
  `}
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    margin: 0 auto;
    width: fit-content;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
    }
  `}
`;

export const IconSuccessWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
